// 7-Day Nervous System Reset — sequential daily course unlocked over time.

export const RESET_DAYS = [
  {
    n: 1,
    title: "Day 1 · Notice the weather",
    eyebrow: "Begin",
    summary:
      "Before you change anything, you have to notice. Today is a noticing day.",
    practice:
      "Three times today — morning, midday, evening — pause for 60 seconds. Place one hand on your chest, one on your belly. Just notice: which one moves more? Where is the breath landing? No judgement. No fixing. Only data.",
    point: { n: "CV 17 (Shan Zhong)", how: "Centre of the chest, between the nipples. Place hand softly." },
    mantra: "I do not have to change to be welcome.",
    closing:
      "Tomorrow we'll begin to lengthen the exhale — the body's gentlest off-switch.",
  },
  {
    n: 2,
    title: "Day 2 · The exhale is medicine",
    eyebrow: "Breath",
    summary:
      "The exhale is the only part of breath your nervous system reads as 'safe to rest.' We'll teach it to be longer.",
    practice:
      "Inhale through the nose for a count of 4. Exhale through pursed lips for a count of 7. Repeat 5 rounds. Do this once in the morning and once before bed. That's it.",
    point: { n: "LU 9 (Tai Yuan)", how: "Inner wrist crease, thumb side. Gentle press while you breathe." },
    mantra: "My exhale is the path home.",
    closing:
      "The simplest practice. Tomorrow we touch the vagus nerve directly.",
  },
  {
    n: 3,
    title: "Day 3 · Cool the vagus nerve",
    eyebrow: "Vagal tone",
    summary:
      "The vagus nerve is your body's parasympathetic highway. Cold on the face triggers a near-instant calming response.",
    practice:
      "Fill a bowl with cold water. Splash your face — especially the forehead, eyes and cheeks — for 30 seconds. Or hold a cold pack to those areas. Notice the slowing.",
    point: { n: "GB 20 (Feng Chi)", how: "Base of the skull, two thumb-widths from spine. Slow circles." },
    mantra: "My body knows how to come back.",
    closing:
      "Cold + slow exhale together is a near-magic reset. Stack them.",
  },
  {
    n: 4,
    title: "Day 4 · Find your safe place",
    eyebrow: "Anchor",
    summary:
      "Safety lives in the body, not the calendar. Today we build an anchor you can return to.",
    practice:
      "Bring to mind a place — real or imagined — where you felt completely safe. Close your eyes. Notice three things: a colour, a temperature, a sound. Spend 90 seconds there. Open your eyes. This is your anchor. Visit twice today.",
    point: { n: "PC 6 (Nei Guan)", how: "Three finger-widths below the inner wrist. Press while you visualise." },
    mantra: "I have a place inside me that is always safe.",
    closing:
      "From here on, every time you remember the place, the nervous system softens a little faster.",
  },
  {
    n: 5,
    title: "Day 5 · The first three minutes",
    eyebrow: "Morning ritual",
    summary:
      "How you arrive in the day teaches your nervous system whether to brace or to soften.",
    practice:
      "Before reaching for your phone tomorrow morning: sit up, feet on the floor. 3 slow exhales. Drink a full glass of warm water. Press ST 36 for 1 minute, each side. Then begin the day.",
    point: { n: "ST 36 (Zu San Li)", how: "Four fingers below the kneecap, one finger lateral to the shin." },
    mantra: "I belong to myself first.",
    closing:
      "Three minutes. The whole arc of the day will lean different.",
  },
  {
    n: 6,
    title: "Day 6 · The body remembers",
    eyebrow: "Release",
    summary:
      "Old tension is patterned in tissue. Gentle, repeated touch tells the body it's okay to let go.",
    practice:
      "Lie down. Knees bent, feet flat. Sway the knees side to side, very slowly, for 2 minutes. Then rest with the knees fallen open. Notice anything that softened.",
    point: { n: "SP 6 (San Yin Jiao)", how: "Four fingers above the inner ankle bone. Press 1 minute each side." },
    mantra: "Slowness is also progress.",
    closing:
      "Tomorrow we put the pieces together into one daily ritual you'll keep.",
  },
  {
    n: 7,
    title: "Day 7 · A ritual you'll keep",
    eyebrow: "Yours now",
    summary:
      "The week's tools, woven into a 5-minute morning ritual. Compact. Effective. Yours.",
    practice:
      "Each morning, in order: (1) sit up, feet on the floor, (2) glass of warm water, (3) five rounds of 4-7 breath, (4) splash cold on the face, (5) press ST 36 for 1 minute each side, (6) one minute in your safe place. End with the mantra of the day from sanoacu.com.",
    point: { n: "All of the above", how: "Layered, in sequence." },
    mantra: "I have what I need. I return to it daily.",
    closing:
      "If you'd like to go deeper — a real session, the full Nervous System Reset protocol, hands-on work — Joannie is here.",
  },
];

export const RESET_COURSE_DURATION_DAYS = 7;
